import styles from '../styles/SectionTitle.module.scss';

export default function SectionTitle({
  title,
  subtitle = null,
  lgSubtitle = false,
  children,
}) {
  return (
    <div className={styles.sectionTitleContainer}>
      <h1 className={styles.sectionTitle}>{title}</h1>
      {
        subtitle &&
        <p className={lgSubtitle ? styles.lgSectionSubtitle : styles.sectionSubtitle}>{subtitle}</p>
      }
      {children}
    </div>
  );
}
